import Layout from '../components/layout';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useRouter } from 'next/router';
import styles from '../styles/coverage.module.scss';

export default function Coverage() {
  const router = useRouter();
  const { t } = useTranslation('coverage');

  return (
    <Layout title={t('title')} lang={router.locale} route={router.route} isHeader isFooter>
        <section className={styles.coverage}>
            <h3>{t('titleCoverage')}</h3>
            <div>
                <p dangerouslySetInnerHTML={{__html: t('supportList', { interpolation: { escapeValue: false }})}} />
                <p dangerouslySetInnerHTML={{__html: t('unsupportedList', { interpolation: { escapeValue: false }})}} />
            </div>
        </section>
    </Layout>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...await serverSideTranslations(locale, ['coverage', 'common']),
  },
});
